import { prop, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { User } from "../../users/_types/user";
import { CaseNote } from "../../cases/_types/case-note";
import { File } from "../../common/_types/file";

export class Template extends Resource {
    public override type = 'templates';

    @prop()
    @required()
    public templateType: string = 'Email';

    @prop()
    @required()
    public name!: string;

    //no se gestiona desde la aplicación: identifica las plantillas que el código busca por código
    @prop()
    public code?: string;

    @prop()
    public subject!: string;
    
    @prop()
    public contentSID?: string;

    @prop()
    public content?: string;

    
    @prop()
    public documentType?: string;

    @prop()
    public fileId?: string;

    public file!: File;
    
    @prop()
    public templateConfig!: any;

    @prop()
    public templateDestinationType!: string | null; 

}